import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef, createRef, useState } from "react";
import { FocusVisibleManager } from "use-focus-visible";
import { MenuItem } from "../menuItem";
import { StyledUL } from "./menuBar.styles";
export function MenuBar({ items = [], ariaLabel, initialActiveItem, onChange, previewId, previewIdExtractor, }) {
    const ref = useRef(null);
    const arrLength = items.length;
    const [refs, setElRefs] = useState([]);
    const [activeItem, setActiveItem] = useState(Object.assign({ menuItemIndex: 0, popupMenuItemIndex: 0 }, initialActiveItem));
    useEffect(() => {
        setElRefs((elRefs) => Array(arrLength)
            .fill(null)
            .map((_, i) => elRefs[i] || createRef()));
    }, [arrLength]);
    function focusMenuItem(index) {
        let ele = refs[index];
        if (!ele) {
            if (index < 0) {
                ele = refs[items.length - 1];
            }
            else {
                [ele] = refs;
            }
        }
        ele.current.firstChild.focus();
    }
    function focusPopupMenuItem(menuItemIndex, popupMenuIndex) {
        const popupMenuRef = refs[menuItemIndex].current
            .children[1];
        const popupMenuItems = popupMenuRef.children;
        const popupMenuItem = popupMenuItems === null || popupMenuItems === void 0 ? void 0 : popupMenuItems[popupMenuIndex];
        if (popupMenuItem) {
            const anchorElement = popupMenuItem.firstChild;
            anchorElement.focus();
        }
    }
    function handleOnFocusNextPopupMenuItem(index) {
        return () => {
            const popupMenu = document.activeElement.parentElement.children[1];
            if (popupMenu) {
                const hasPopupMenu = !!popupMenu && popupMenu.getAttribute("role") === "menu";
                if (hasPopupMenu) {
                    // menuItem focused, we jump to popupMenu and focuses the first item
                    popupMenu.firstChild.firstChild.focus();
                    return;
                }
            }
            // popupMenuItem focused, we focuse the next item
            const currentFocusedAnchorElement = document.activeElement;
            const nextLi = currentFocusedAnchorElement.parentElement.nextElementSibling;
            if (nextLi) {
                const nextAnchorElement = nextLi.firstChild;
                nextAnchorElement.focus();
            }
            else {
                focusPopupMenuItem(index, 0);
            }
        };
    }
    function handleOnFocusPreviousPopupMenuItem(index, lastElementIndex) {
        return () => {
            const popupMenu = document.activeElement.parentElement.children[1];
            if (popupMenu) {
                const hasPopupMenu = !!popupMenu && popupMenu.getAttribute("role") === "menu";
                if (hasPopupMenu) {
                    // menuItem focused, we jump to popupMenu and focuses the last item
                    popupMenu.lastChild.firstChild.focus();
                    return;
                }
            }
            // popupMenuItem focused, we focuse the previous item
            const currentFocusedAnchorElement = document.activeElement;
            const nextLi = currentFocusedAnchorElement.parentElement.previousElementSibling;
            if (nextLi) {
                const anchorElement = nextLi.firstChild;
                anchorElement.focus();
            }
            else {
                focusPopupMenuItem(index, lastElementIndex);
            }
        };
    }
    return (_jsx(StyledUL, Object.assign({ "data-preview-id": previewId, ref: ref, role: "menubar", "aria-label": ariaLabel }, { children: items.map((item, index) => {
            var _a, _b;
            return (_jsx(FocusVisibleManager, { children: _jsx(MenuItem, { "data-preview-id": typeof previewIdExtractor === "function"
                        ? previewIdExtractor(item, index)
                        : undefined, onClick: (el) => {
                        if (!item.isDisabled) {
                            const nextActiveItem = Object.assign({ menuItemIndex: index }, el);
                            setActiveItem(nextActiveItem);
                            if (typeof onChange === "function") {
                                onChange(nextActiveItem);
                            }
                            if (typeof item.onClick === "function") {
                                item.onClick(nextActiveItem);
                            }
                        }
                    }, onChange: onChange, index: index, isDisabled: item.isDisabled, isActive: (activeItem === null || activeItem === void 0 ? void 0 : activeItem.menuItemIndex) === index, ref: refs[index], onFocusPreviousMenuItem: () => {
                        focusMenuItem(index - 1);
                    }, onFocusNextMenuItem: () => {
                        focusMenuItem(index + 1);
                    }, onFocusNextPopupMenuItem: handleOnFocusNextPopupMenuItem(index), onFocusPreviousPopupMenuItem: handleOnFocusPreviousPopupMenuItem(index, ((_b = (_a = item.popupMenu) === null || _a === void 0 ? void 0 : _a.popupMenuItems) === null || _b === void 0 ? void 0 : _b.length) - 1), name: item.name, popupMenu: Object.assign(Object.assign({}, item.popupMenu), { activeItemIndex: activeItem.popupMenuItemIndex, url: item.url }), setActiveItem: setActiveItem }) }, JSON.stringify(item)));
        }) })));
}
